import { getInjectorData } from '~/src/features/videocontrol/pageBlocks/StepsInstall/utils';
import { ACTIONS_TYPES } from '~/src/features/videocontrol/Provider/actionTypes';
import { initialState } from '~/src/features/videocontrol/Provider/index';
import type { IState, TActions } from '~/src/features/videocontrol/Provider/types';

export function reducer(state: IState, action: TActions): IState {
    switch (action.type) {
        case ACTIONS_TYPES.ADD_CAMERA_ITEM:
            return {
                ...state,
                cameras: {
                    ...state.cameras,
                    [action.payload.id]: {
                        ...action.payload,
                    },
                },
            };
        case ACTIONS_TYPES.REMOVE_CAMERA_ITEM:
            return {
                ...state,
                cameras: {
                    ...Object.fromEntries(
                        Object.entries({ ...state.cameras })
                            .filter(([, camera]) => camera.id !== action.payload),
                    ),
                },
            };
        case ACTIONS_TYPES.RESET_CAMERAS_ITEMS:
            return {
                ...state,
                cameras: {
                    ...action.payload,
                },
            };

        case ACTIONS_TYPES.INCREMENT_CAMERA_COUNT:
            return {
                ...state,
                cameras: {
                    ...state.cameras,
                    [action.payload.id]: {
                        ...state.cameras[action.payload.id],
                        count: action.payload.currentCount + 1,
                    },
                },
            };
        case ACTIONS_TYPES.INCREMENT_CAMERA_PRICE_WITH_COUNT:
            return {
                ...state,
                cameras: {
                    ...state.cameras,
                    [action.payload.id]: {
                        ...state.cameras[action.payload.id],
                        priceMonthWithCount: state.cameras[action.payload.id].priceMonthWithCount + action.payload.priceMonth,
                        priceTotalWithCount: state.cameras[action.payload.id].priceTotalWithCount + action.payload.priceTotal,
                    },
                },
            };
        case ACTIONS_TYPES.DECREMENT_CAMERA_PRICE_WITH_COUNT:
            return {
                ...state,
                cameras: {
                    ...state.cameras,
                    [action.payload.id]: {
                        ...state.cameras[action.payload.id],
                        priceMonthWithCount: state.cameras[action.payload.id].priceMonthWithCount - action.payload.priceMonth,
                        priceTotalWithCount: state.cameras[action.payload.id].priceTotalWithCount - action.payload.priceTotal,
                    },
                },
            };
        case ACTIONS_TYPES.DECREMENT_CAMERA_COUNT:
            return {
                ...state,
                cameras: {
                    ...state.cameras,
                    [action.payload.id]: {
                        ...state.cameras[action.payload.id],
                        count: action.payload.currentCount - 1,
                    },
                },
            };
        case ACTIONS_TYPES.DECREMENT_TOTAL_COUNT_CAMERAS:
            return {
                ...state,
                totalCountCameras: state.totalCountCameras - action.payload,
            };
        case ACTIONS_TYPES.INCREMENT_TOTAL_COUNT_CAMERAS:
            return {
                ...state,
                totalCountCameras: state.totalCountCameras + action.payload,
            };
        case ACTIONS_TYPES.RESET_TOTAL_COUNT_CAMERAS:
            return {
                ...state,
                totalCountCameras: 0,
            };
        case ACTIONS_TYPES.INCREMENT_INJECTOR:
            return {
                ...state,
                injector: {
                    ...state.injector,
                    count: state.injector.count + action.payload,
                    priceTotalWithCount: state.injector.priceTotal * (state.injector.count + 1),
                },
            };
        case ACTIONS_TYPES.DECREMENT_INJECTOR:
            return {
                ...state,
                injector: {
                    ...state.injector,
                    count: state.injector.count - action.payload,
                    priceTotalWithCount: state.injector.priceTotal * ((state.injector.count - 1) || 1),
                },
            };
        case ACTIONS_TYPES.RESET_INJECTOR:
        case ACTIONS_TYPES.INIT_INJECTOR:
            return {
                ...state,
                injector: getInjectorData(action.payload),
            };
        case ACTIONS_TYPES.SET_LOCATION_INSTALL:
            return {
                ...state,
                installLocation: action.payload,
            };
        case ACTIONS_TYPES.SET_PLAN:
            return {
                ...state,
                plan: action.payload,
            };
        case ACTIONS_TYPES.SET_OPTION:
            return {
                ...state,
                planOption: action.payload,
            };
        case ACTIONS_TYPES.SET_RESET_ALL:
            return {
                ...state,
                ...initialState,
            };
        default:
            return state;
    }
}
